import React from 'react';

const ImpersonationBanner = () => {
  const adminToken = localStorage.getItem('sa_admin_token');
  if (!adminToken) return null;
  let info = {};
  try { info = JSON.parse(localStorage.getItem('sa_impersonating') || '{}'); } catch { /* noop */ }
  const exitView = () => {
    localStorage.setItem('token', adminToken);
    localStorage.removeItem('sa_admin_token');
    localStorage.removeItem('sa_impersonating');
    window.location.href = '/super-admin';
  };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[999] bg-amber-500 text-slate-900 px-4 py-2.5 flex flex-wrap items-center justify-center gap-3 text-sm font-bold shadow-2xl" data-testid="impersonation-banner">
      <span>👁 Viewing as {info.name || info.email || 'user'} · {info.role || 'user'} ({info.subscription_tier || 'free'})</span>
      <button onClick={exitView} className="bg-slate-900 text-white rounded-full px-4 py-1.5 text-xs font-black hover:bg-slate-800" data-testid="impersonation-exit-btn">
        Return to Super Admin
      </button>
    </div>
  );
};

export default ImpersonationBanner;
